<template>
  <div class="text-13 min-h-6 flex items-center overflow-hidden">
    <template v-if="!payload.tool_name">{{ $t('evaluate_editor.data-export') }}</template>
    <template v-else>
      <span v-if="payload.variable"><VariableChip :name="payload.variable" :index="6" class="mr-1 text-12" /></span>
      <span v-if="payload.variable" class="text-pink-500 mr-1">{{ $t('equals') }}</span>
      <span class="truncate">
        {{ payload.tool_name }} &rarr; {{ serviceName }} &rarr; {{ destinationName }}<template v-if="servicePath"> / {{ servicePath }}</template>
      </span>
    </template>
  </div>
</template>

<script>
/**
 * One-line summary of a data export block on the flow canvas: tool, service,
 * destination and, for file services, the path.
 */
import { DATA_ADAPTERS } from '@/constants';
import SERVICES from './data-export/services';

export default {
  name: 'DataExportOverview',
  props: {
    /** The evaluate item: { id, type, payload }. */
    item: Object,
    /** The step's evaluate items. */
    evaluate: Array,
  },
  computed: {
    /**
     * @returns {object} The block payload.
     */
    payload() {
      return this.item.payload || {};
    },
    /**
     * @returns {object|null} The chosen export service.
     */
    service() {
      return SERVICES[this.payload.service] || null;
    },
    /**
     * @returns {string} The service's display name.
     */
    serviceName() {
      return this.service?.name || this.payload.service || '';
    },
    /**
     * @returns {string} The destination path from the chosen service's own settings, if it has one.
     */
    servicePath() {
      return (this.service && this.payload[this.service.configKey]?.path) || '';
    },
    /**
     * @returns {string} The destination adapter's display name.
     */
    destinationName() {
      const type = this.payload.destination_adapter;
      return DATA_ADAPTERS[type]?.name || type || '';
    },
  },
};
</script>
